// extracted by mini-css-extract-plugin
export default {"functionBtn":"FunctionBtn_functionBtn__M1zLK","link":"FunctionBtn_link__DFJkF","wrapper":"FunctionBtn_wrapper__xOslo","icon":"FunctionBtn_icon__VTKTP"};